"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var NeutralIcon = function NeutralIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    className: className,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    fill: color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,18.8571429 C14.8916649,18.8571429 18.8571429,14.8916649 18.8571429,10 C18.8571429,5.10833507 14.8916649,1.14285714 10,1.14285714 C5.10833507,1.14285714 1.14285714,5.10833507 1.14285714,10 C1.14285714,14.8916649 5.10833507,18.8571429 10,18.8571429 Z M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0012752,9.80952381 L6,9.80952381 C5.68440871,9.80952381 5.42857143,10.0653611 5.42857143,10.3809524 C5.42857143,10.6965437 5.68440871,10.952381 6,10.952381 L14.0012752,10.952381 C14.3168665,10.952381 14.5727038,10.6965437 14.5727038,10.3809524 C14.5727038,10.0653611 14.3168665,9.80952381 14.0012752,9.80952381 Z"
  })));
};
var defaultProps = {
  color: _constants.colors.darkYellow,
  width: 20,
  height: 20
};
NeutralIcon.defaultProps = defaultProps;
var _default = NeutralIcon;
exports["default"] = _default;